module.exports = __webpack_public_path__ + "img/0Q3A6453_FoamcoreMatted.b1e7ccf7.jpg";